// The Model Serving page's data: every model (with versions + live status) and
// the GPU presets this cluster offers (for $/hr). Polls fast while anything is
// warming or downloading, slowly otherwise.
import { useCallback, useEffect, useState } from "react";
import { modelServingApi } from "../../api/client";
import { modelStatus } from "./modelServingModel";
import { errorText } from "./modelServingUi";

export const FAST_MS = 5000;
export const SLOW_MS = 30000;

export function useModelServing() {
  const [models, setModels] = useState(null);
  const [error, setError] = useState(null);
  const [presets, setPresets] = useState({});
  const [presetsError, setPresetsError] = useState(null);
  const [stamp, setStamp] = useState(0);

  const load = useCallback(async () => {
    try {
      const r = await modelServingApi.catalog();
      setModels(r.data || []);
      setError(null);
    } catch (e) {
      setError(errorText(e));
      setModels((m) => m || []);
    } finally {
      setStamp((s) => s + 1);
    }
  }, []);

  useEffect(() => {
    load();
    modelServingApi.gpuOptions()
      .then((r) => setPresets(Object.fromEntries((r.data || []).map((o) => [o.key, o]))))
      .catch((e) => setPresetsError(errorText(e)));
  }, [load]);

  const busy = (models || []).some((m) => ["warming", "downloading"].includes(modelStatus(m)));
  useEffect(() => {
    if (models === null) return undefined;
    const t = setTimeout(load, busy ? FAST_MS : SLOW_MS);
    return () => clearTimeout(t);
  }, [stamp, busy, load, models]);

  return { models, error, presets, presetsError, load, stamp };
}
